import { computePivot, flatRows, flattenPivotForExport } from "@/lib/analytics/pivot";
import type { FlatEmployeeRow } from "@/lib/analytics/fieldCatalog";
import type { ReportTile } from "./types";

/**
 * Build the flat Record[] for export from a tile (pivot or flat mode).
 *
 * Lives outside `PivotOutput.tsx` so that file exports only React components
 * and Fast Refresh keeps working (react-refresh/only-export-components).
 */
export function tileExportRows(
  dataset: FlatEmployeeRow[],
  tile: ReportTile,
  labelFor: (k: keyof FlatEmployeeRow) => string,
  t: (k: string) => string
): Record<string, any>[] {
  if (tile.config.mode === "flat") return flatRows(dataset, tile.config, labelFor);
  const pivot = computePivot(dataset, tile.config);
  return flattenPivotForExport(pivot, labelFor, {
    headcountLabel: t("analytics.pivot.headcount"),
    totalLabel: t("analytics.pivot.grandTotal"),
  });
}
